<template>
    <div class="creatorWrapper">
        <div class="header">
            <h3>欢迎来到创作中心，打造名师IP，传播优质资源！</h3>
        </div>
        <el-card class="content">
            <div class="tab">
                <el-menu :default-active="activeIndex" class="el-menu-tab" mode="horizontal" @select="handleTabSelect">
                    <el-menu-item index="2">视频上传</el-menu-item>
                    <el-menu-item index="4">音频上传</el-menu-item>
                    <el-menu-item index="1">文档上传</el-menu-item>
                </el-menu>
            </div>
            <div class="tab-content">
                <upload-ready :type="activeIndex"/>
            </div>
        </el-card>
    </div>
</template>
<script>
  import uploadReady from '@/components/Creator/uploadReady';

  export default {
    name: 'Creator',
    components: {
      uploadReady
    },
    data () {
      return {
        activeIndex: '2'
      };
    },
    methods: {
      handleTabSelect (key) {
        this.activeIndex = key;
      }
    }
  };
</script>
<style lang="scss">
    .creatorWrapper {
        .tab {
            .el-menu-tab {
                width: 100%;
                display: flex;

                .el-menu-item {
                    flex: 1;
                    text-align: center;
                }
            }
        }
    }
</style>
